import styled from 'styled-components';

export const StyledMenu = styled.nav`
  display: ${({ open }) => open ? 'flex' : 'none'};
  flex-direction: column;
  justify-content: flex-start;
  background: white;
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
  height: 100vh;
  text-align: left;
  min-width: 250px;
  padding: 2rem 0.8rem 0;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1001;
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
  transition: transform 0.3s ease-in-out;

  @media (max-width: 576px) {
    width: 75%;
  }

  ul {
    padding-left: 0;
  }
  
  ul li {
    cursor: pointer;
    font-size: 15px;
    text-transform: uppercase;
    padding: 5px 0;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #0D0C1D;
    text-decoration: none;
    transition: color 0.3s linear;
    
    :first-child {
      margin-top: 10px;
    }
    
    svg {
      path {
        fill: currentColor !important;
      }
    }
    img {
      width: 1.5em;
      height: 1.5em;
      object-fit: cover;
      margin-right: 10px;
      
      @media (max-width: 576px) {
        width: 1.05em;
        height: 1.05em;
      }
    }
       
    span {
      position: unset !important;
      transform: unset;
      font-size: 15px;
      color: var(--text2) !important;
    }

    @media (max-width: 576px) {
      font-size: 1.5rem;
      text-align: center;
    }

    &:hover {
      color: #343078;
    }
  }
  
  ul li.c-svg-color img {
    filter: invert(32%) sepia(32%) saturate(2573%) hue-rotate(51deg) brightness(75%) contrast(128%);
  }
`;
